export default __webpack_public_path__ + "static/media/logotype-project-daily-rebbe-video.06d42216.png";